<template>
  <main class="auth-page">
    <section class="auth-card" aria-labelledby="register-title">
      <header class="auth-header">
        <img src="@/assets/images/lengedu.jpg" alt="Lengedu" class="auth-logo">
        <span class="auth-eyebrow">ÖĞRENCİ PANELİ</span>
        <h1 id="register-title">İlk adımı birlikte atalım</h1>
        <p>Ücretsiz hesabınızı oluşturun, İngilizce yolculuğunuza başlayın.</p>
      </header>
      <form class="auth-form" @submit.prevent="submit" :aria-busy="form.isLoading" novalidate>
        <div class="auth-field">
          <label for="fullName">Ad soyad</label>
          <input id="fullName" v-model="form.fullName" type="text" class="ym-disable-keys" placeholder="Adınız ve soyadınız" autocomplete="name" :disabled="form.isLoading" :class="inputClass(touched.fullName, errors.fullName)" :aria-invalid="touched.fullName && !!errors.fullName" :aria-describedby="touched.fullName && errors.fullName ? 'name-error' : undefined" @blur="touched.fullName = true" required>
          <p v-if="touched.fullName && errors.fullName" id="name-error" class="auth-error">{{ errors.fullName }}</p>
        </div>
        <div class="auth-field">
          <label for="phonenumber">Telefon numarası</label>
          <input id="phonenumber" v-model="form.phone" type="tel" class="ym-disable-keys" placeholder="Telefon numaranız" autocomplete="tel" :disabled="form.isLoading" :class="inputClass(touched.phone, errors.phone)" :aria-invalid="touched.phone && !!errors.phone" :aria-describedby="touched.phone && errors.phone ? 'phone-error' : undefined" @blur="touched.phone = true" inputmode="numeric" pattern="[0-9]*" @input="onlyNumber" required>
          <p v-if="touched.phone && errors.phone" id="phone-error" class="auth-error">{{ errors.phone }}</p>
        </div>
        <div class="auth-field">
          <label for="email">E-posta adresi</label>
          <input id="email" v-model="form.email" type="email" class="ym-disable-keys" placeholder="ornek@eposta.com" autocomplete="email" inputmode="email" :disabled="form.isLoading" :class="inputClass(touched.email, errors.email)" :aria-invalid="touched.email && !!errors.email" :aria-describedby="touched.email && errors.email ? 'email-error' : undefined" @blur="touched.email = true" required>
          <p v-if="touched.email && errors.email" id="email-error" class="auth-error">{{ errors.email }}</p>
        </div>
        <button class="auth-submit" type="submit" :disabled="form.isLoading">
          <span v-if="form.isLoading" class="auth-spinner" aria-hidden="true"></span>
          <span aria-live="polite">{{ form.isLoading ? 'Hesabınız oluşturuluyor…' : 'Ücretsiz kayıt ol' }}</span>
          <span v-if="!form.isLoading" aria-hidden="true">→</span>
        </button>
        <p class="auth-policy">Kayıt olarak, kişisel verilerin işlenmesi hakkında <a href="https://lengedu.com/Legal/PrivacyPolicy" target="_blank" rel="noopener noreferrer">Gizlilik Politikasını</a> kabul etmiş sayılırsınız.</p>
      </form>
      <p class="auth-register">Zaten hesabınız var mı? <router-link to="/login">Giriş yapın</router-link></p>
    </section>
    <footer class="auth-footer"><VersionNumber /></footer>
  </main>
</template>

<script>
    import { LoadingToast,UpdateToast,ToastType } from "@/common/notification.js";
    import VersionNumber from "@/components/Shared/VersionNumber.vue";
    import { mapActions } from "vuex";
    export default {
      name: "RegisterPage",
      components: {
        VersionNumber
      },
      computed:{
        errors() {
          return {
            fullName: this.validateFullName(this.form.fullName),
            phone: this.validatePhone(this.form.phone),
            email: this.validateEmail(this.form.email)
          };
        },
        isFormValid() {
          return !this.errors.fullName && !this.errors.phone && !this.errors.email;
        }
      },
      data() {
        return {
          form: {
            fullName: "",
            email:"",
            phone: "",
            isLoading:false
          },
          touched: {
            fullName: false,
            phone: false,
            email: false
          }
        };
      },
      methods: {
        ...mapActions(["StudentPanelRegisterAsync"]),
        submit(){
          if (this.form.isLoading) return;
          this.touched.fullName = true;
          this.touched.phone = true;
          this.touched.email = true;

          if (!this.isFormValid) return;
          
          this.form.isLoading=true;
          let toastId = LoadingToast();
          let model = {
            fullName : this.form.fullName,
            phoneNumber : this.form.phone,
            eMail : this.form.email
          };
          this.StudentPanelRegisterAsync(model)
          .then((res)=>{
            this.form.isLoading=false;
            UpdateToast(toastId,res,ToastType().SUCCESS,3000);
            this.clearForm();
            this.$router.push("/login");
          })
          .catch((err)=>{
            this.form.isLoading=false;
            UpdateToast(toastId,err,ToastType().ERROR);
          });
        },
        inputClass(touched, error) {
          if (!touched) return "";
          return error ? "is-invalid" : "is-valid";
        },
        validateFullName(value) {
          const v = (value || "").trim().replace(/\s+/g, " ");
          if (!v) return "Ad soyad zorunludur.";
          if (v.length < 5) return "Ad soyad çok kısa.";

          // En az 2 kelime
          const parts = v.split(" ");
          if (parts.length < 2) return "Lütfen ad ve soyadı birlikte yazın.";

          // Türkçe karakterler dahil sadece harf + boşluk + - + '
          const nameRegex = /^[A-Za-zÇĞİÖŞÜçğıöşü]+([-' ][A-Za-zÇĞİÖŞÜçğıöşü]+)*$/;
          if (!nameRegex.test(v)) return "Sadece harf, boşluk, - ve ' kullanılabilir.";

          // Her kelime en az 2 harf 
          if (parts.some(p => p.replace(/[-']/g, "").length < 2)) {
            return "Ad/soyad bölümleri en az 2 harf olmalı.";
          }

          return "";
        },
        validatePhone(value) {
          const v = (value || "").trim();
          if (!v) return "Telefon zorunludur.";
          if (!/^\d{5,}$/.test(v)) return "Telefon formatı en az 5 haneli olmalı.";
          return "";
        },
        validateEmail(value) {
          const v = (value || "").trim();
          if (!v) return "E-posta zorunludur.";

          // Basit ama sağlam email regex
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
          if (!emailRegex.test(v)) return "Geçerli bir e-posta girin.";
          if (v.length > 254) return "E-posta çok uzun.";
          return "";
        },
        onlyNumber(e) {
          e.target.value = e.target.value.replace(/\D/g, "");
          this.form.phone = e.target.value;
        },
        clearForm(){
          this.form = {
            fullName: "",
            email:"",
            phone: "",
            isLoading:false
          };
          this.touched = {
            fullName: false,
            phone: false,
            email: false
          };
        }
      },
    };
  </script>

<style scoped src="@/assets/styles/auth.css"></style>
